import { ComponentBuilder } from "@sitecore-jss/sitecore-jss-nextjs";

import PartialDesignDynamicPlaceholder from "modules/PartialDesignDynamicPlaceholder";
import ContactUs from "modules/ContactUs";
import Header from "modules/Header";
import { HeroBordered, HeroFullScreen } from "modules/Hero";
import HeroCarousel from "modules/HeroCarousel";
import HeroCarouselElement from "modules/HeroCarousel/HeroCarouselElement";
import MainNavigation from "modules/MainNavigation";
import Footer from "modules/Footer";
import SearchBox from "modules/SearchBox";
import dynamic from "next/dynamic";

const componentsDynamic = new Map();

componentsDynamic.set("ContactUs", {
    Default: ContactUs,
});
componentsDynamic.set("Footer", {
    Default: Footer,
});
componentsDynamic.set("Header", {
    Default: Header,
});
componentsDynamic.set("Hero", {
    Default: HeroBordered,
    FullScreen: HeroFullScreen,
});
componentsDynamic.set("HeroCarousel", {
    Default: HeroCarousel,
});
componentsDynamic.set("HeroCarouselElement", {
    Default: HeroCarouselElement,
});
componentsDynamic.set("MainNavigation", {
    Default: MainNavigation,
});
componentsDynamic.set("SearchBox", {
    Default: SearchBox,
});
componentsDynamic.set("PartialDesignDynamicPlaceholder", PartialDesignDynamicPlaceholder);

// Dynamic components
const Accordion = dynamic(() => import("modules/Accordion"));
const AccordionElement = dynamic(() => import("modules/Accordion/AccordionElement"));
const AnchorNavigation = dynamic(() => import("modules/AnchorNavigation"));
const ArticleListCarousel = dynamic(() => import("modules/ArticleListCarousel"));
const Breadcrumb = dynamic(() => import("modules/Breadcrumb"));
const Content = dynamic(() => import("modules/Content"));
const DigitsAndData = dynamic(() => import("modules/DigitsAndData"));
const DigitsAndDataElement = dynamic(() => import("modules/DigitsAndData/DigitsAndDataElement"));
const Download = dynamic(() => import("modules/Download"));
const DynamicLinkList = dynamic(() => import("modules/DynamicLinkList"));
const GridTeaserList = dynamic(() => import("modules/GridTeaserList"));
const GridTeaserElementColumns2 = dynamic(() =>
    import("modules/GridTeaserList/GridTeaserElement").then((mod) => mod.GridTeaserElementColumns2)
);
const GridTeaserElementColumns3 = dynamic(() =>
    import("modules/GridTeaserList/GridTeaserElement").then((mod) => mod.GridTeaserElementColumns3)
);
const GridTeaserElementImageLeft = dynamic(() =>
    import("modules/GridTeaserList/GridTeaserElement").then((mod) => mod.GridTeaserElementImageLeft)
);
const GridTeaserElementImageRight = dynamic(() =>
    import("modules/GridTeaserList/GridTeaserElement").then(
        (mod) => mod.GridTeaserElementImageRight
    )
);
const Iframe = dynamic(() => import("modules/IFrame"));
const Image = dynamic(() => import("modules/Content/Image"));
const ImageCarousel = dynamic(() => import("modules/ImageCarousel"));
const ImageCarouselElement = dynamic(() => import("modules/ImageCarousel/ImageCarouselElement"));
const QAList = dynamic(() => import("modules/QAList"));
const QAElement = dynamic(() => import("modules/QAList/QAElement"));
const Quote = dynamic(() => import("modules/Quote"));
const QuoteElement = dynamic(() => import("modules/Quote/QuoteElement"));
const RichText = dynamic(() => import("modules/Content/RichText").then((mod) => mod.RichText));
const RichTextBoxed = dynamic(() =>
    import("modules/Content/RichText").then((mod) => mod.RichTextBoxed)
);
const SearchResults = dynamic(() => import("modules/SearchResults"));
const Showcase = dynamic(() => import("modules/Showcase"));
const Video = dynamic(() => import("modules/Video"));

componentsDynamic.set("Accordion", {
    Default: Accordion,
});
componentsDynamic.set("AccordionElement", {
    Default: AccordionElement,
});
componentsDynamic.set("AnchorNavigation", {
    Default: AnchorNavigation,
});
componentsDynamic.set("ArticleListCarousel", {
    Default: ArticleListCarousel,
});
componentsDynamic.set("Breadcrumb", {
    Default: Breadcrumb,
});
componentsDynamic.set("Content", {
    Default: Content,
});
componentsDynamic.set("DigitsAndData", {
    Default: DigitsAndData,
});
componentsDynamic.set("DigitsAndDataElement", {
    Default: DigitsAndDataElement,
});
componentsDynamic.set("Download", {
    Default: Download,
});
componentsDynamic.set("DynamicLinkList", {
    Default: DynamicLinkList,
});

componentsDynamic.set("GridTeaserList", {
    Default: GridTeaserList,
});
componentsDynamic.set("GridTeaserElement", {
    Default: GridTeaserElementColumns2,
    Columns3: GridTeaserElementColumns3,
    ImageLeft: GridTeaserElementImageLeft,
    ImageRight: GridTeaserElementImageRight,
});
componentsDynamic.set("IFrame", {
    Default: Iframe,
});
componentsDynamic.set("Image", {
    Default: Image,
});
componentsDynamic.set("ImageCarousel", {
    Default: ImageCarousel,
});
componentsDynamic.set("ImageCarouselElement", {
    Default: ImageCarouselElement,
});
componentsDynamic.set("QAList", {
    Default: QAList,
});
componentsDynamic.set("QAElement", {
    Default: QAElement,
});
componentsDynamic.set("Quote", {
    Default: Quote,
});
componentsDynamic.set("QuoteElement", {
    Default: QuoteElement,
});
componentsDynamic.set("RichText", {
    Default: RichText,
    Boxed: RichTextBoxed,
});
componentsDynamic.set("SearchResults", {
    Default: SearchResults,
});
componentsDynamic.set("Showcase", {
    Default: Showcase,
});
componentsDynamic.set("Video", {
    Default: Video,
});

export const componentBuilder = new ComponentBuilder({
    components: componentsDynamic,
});

export const moduleFactory = componentBuilder.getModuleFactory();
